<template>
  <v-card style="height:250px;">
    <v-toolbar
      color="primary"
      dark
    >
      <h1>Logged Out</h1>
    </v-toolbar>
    <v-card-text class="d-flex justify-center my-6">
      <v-btn
        color="primary"
        to="/"
      >
        Return to login
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>


export default {
   mounted(){
    //location.reload()
   }
}
</script>
